import React, { useEffect, useState } from 'react';
import api from '../api';
import { useSortedPaginated, SortableTh, Pagination } from '../components/TableControls';

function StoreTable({ rows, colA, colB, labelA, labelB, defaultSort }) {
  const { paginated, sortKey, sortDir, setSort, page, setPage, perPage, setPerPage, total } = useSortedPaginated(rows, defaultSort, 'desc');
  return (
    <>
      <Pagination page={page} perPage={perPage} total={total} onPage={setPage} onPerPage={setPerPage} />
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <SortableTh colKey={colA} sortKey={sortKey} sortDir={sortDir} onSort={setSort}>{labelA}</SortableTh>
              <SortableTh colKey={colB} sortKey={sortKey} sortDir={sortDir} onSort={setSort}>{labelB}</SortableTh>
            </tr>
          </thead>
          <tbody>
            {paginated.map((s, i) => (
              <tr key={s.store_id || s.item_id || i}>
                <td>{s[colA]}</td>
                <td>{s[colB]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination page={page} perPage={perPage} total={total} onPage={setPage} onPerPage={setPerPage} />
    </>
  );
}

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/reports/dashboard').then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Cargando panel...</p>;
  if (!data) return <p>No se pudo cargar el panel.</p>;

  return (
    <div>
      <div className="page-header"><h1>Panel</h1></div>

      <div className="card-grid">
        <div className="stat-card">
          <div className="label">% de Pérdida</div>
          <div className="value">{data.shrinkage_percentage}%</div>
        </div>
        <div className="stat-card">
          <div className="label">% de Merma (Total)</div>
          <div className="value">{data.waste_percentage}%</div>
        </div>
      </div>

      <div className="card">
        <h3 style={{ marginBottom: 12 }}>Inventario por Tienda (Unidades)</h3>
        <StoreTable rows={data.inventory_per_store} colA="store_name" colB="total_units" labelA="Tienda" labelB="Unidades Totales" defaultSort="total_units" />
      </div>

      <div className="card">
        <h3 style={{ marginBottom: 12 }}>Rotación de Stock</h3>
        <StoreTable rows={data.stock_turnover} colA="store_name" colB="turnover" labelA="Tienda" labelB="Índice de Rotación" defaultSort="turnover" />
      </div>

      <div className="card">
        <h3 style={{ marginBottom: 12 }}>Artículos con Más Pérdidas</h3>
        {data.top_lost_items.length === 0
          ? <p style={{ color: 'var(--text-3)', fontSize: 14 }}>Sin datos aún</p>
          : <StoreTable rows={data.top_lost_items} colA="item_name" colB="total_loss" labelA="Artículo" labelB="Unidades Perdidas" defaultSort="total_loss" />
        }
      </div>
    </div>
  );
}
